import { ActionTracker } from "@dpdgroupuk/react-event-tracker";

const { REACT_APP_IW_APIS_URL } = process.env;

export default new ActionTracker({
  projectRef: "IW",
  debug: false,
  url: `${REACT_APP_IW_APIS_URL}/v1/analytics`,
});
